import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const FileStatusPanelItem = /*#__PURE__*/ memo((param)=>{
    let { className, title, subtitle, avatar, buttons, previewLoader, onClick } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("flex justify-between", className),
        onClick: onClick,
        children: [
            previewLoader,
            /*#__PURE__*/ _jsxs("div", {
                className: "flex shrink py-1",
                children: [
                    avatar,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-1 flex-col justify-center",
                        children: [
                            title,
                            subtitle
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pane-item-buttons flex shrink-0 justify-end gap-1 pl-2.5",
                children: buttons
            })
        ]
    });
});
FileStatusPanelItem.displayName = "FileStatusPanelItem";
